/* Ecochic · Ingredientes (FLUJO_FRONTEND_ECOCHIC_v1 §7): índice y ficha del metaobjeto «ingrediente».
   Portado de web-v3/js/views/ingredientes.js. Productos que lo contienen = tag activo:<slug> (PLAN v2, ESPEC §2.4).
   Sin campo «familia» en el metaobjeto: no hay bloques por familia ni insignia «Aromático» hasta que exista. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function na(s) { return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function eur(v) { var n = parseFloat(v); return (isNaN(n) || n === 0) ? '' : n.toFixed(2).replace('.', ',') + ' €'; }
  function ING() { try { return JSON.parse(document.getElementById('eco-ingredients').textContent); } catch (e) { return []; } }
  function bySlug() { var m = {}; ING().forEach(function (i) { m[i.slug] = i; }); return m; }
  function relevant(ing) { try { return !!(ing && Eco.Profile.relevantIngredient(ing)); } catch (e) { return false; } }
  function personalized() { try { return Eco.Profile.personalized(); } catch (e) { return false; } }
  function hasActive(p, slug) { return (p.tags || []).some(function (t) { return na(t).replace(/\s+/g, '') === 'activo:' + slug; }); }
  function productsWith(slug) { return (window.PRODUCTS || []).filter(function (p) { return !(window.ECO_DATA && ECO_DATA.isService(p.h)) && hasActive(p, slug); }); }

  /* ---------- índice ---------- */
  function initIndex(root) {
    var pool = root.querySelector('[data-ingx-pool]'), list = root.querySelector('[data-ingx-list]'); if (!pool || !list) return;
    var items = [].slice.call(pool.querySelectorAll('[data-jm-ingx-item]'));
    var M = bySlug();
    var q = root.querySelector('[data-jm-ingx-q]'), count = root.querySelector('[data-jm-ingx-count]'), empty = root.querySelector('[data-jm-ingx-empty]');
    var G = { fallback: '', groups: [] }; try { G = JSON.parse(root.querySelector('[data-ingx-groups]').textContent); } catch (e) {}
    var state = { ev: '', skin: '', onlyRel: false, q: '' };

    // Regla 5: cada ficha cae en el primer grupo cuyas palabras aparecen en su familia (sin acentos)
    function groupOf(li) {
      var f = na(li.getAttribute('data-familia'));
      if (!f) return -1;
      for (var i = 0; i < G.groups.length; i++) {
        var keys = String(G.groups[i].keys || '').split(',').map(function (k) { return na(k.trim()); }).filter(Boolean);
        if (keys.some(function (k) { return f.indexOf(k) >= 0; })) return i;
      }
      return -1;
    }
    items.forEach(function (li) {
      var g = groupOf(li); li._g = g;
      var arom = li.querySelector('[data-ingx-arom]'); if (arom) arom.hidden = !(g >= 0 && G.groups[g].aromatic);
    });

    // Regla 2: facetas presentes; piel = todos los para_piel salvo «todas», alfabético.
    // C378: la etiqueta del chip sale de eco_chip_names (sin nombre, sin chip); el valor data-v sigue siendo el del dato
    // (los valores con el mismo nombre, p. ej. «reactiva» e «irritada» → «sensible», comparten chip: data-v = valores con «,»)
    var CN = {}; try { CN = JSON.parse(document.getElementById('eco-ing-full').textContent).chip_names || {}; } catch (e) {}
    var skins = [], skinVals = {};
    items.forEach(function (li) {
      (li.getAttribute('data-skin') || '').split('|').forEach(function (x) {
        x = x.trim(); var n = CN[x.toLowerCase()];
        if (!x || na(x) === 'todas' || !n) return;
        if (skins.indexOf(n) < 0) { skins.push(n); skinVals[n] = []; }
        if (skinVals[n].indexOf(na(x)) < 0) skinVals[n].push(na(x));
      });
    });
    skins.sort(function (a, b) { return a.localeCompare(b, 'es'); });
    function chips(group, vals) {
      var g = root.querySelector('[data-ingx-group="' + group + '"]'); if (!g) return;
      if (!vals.length) { g.hidden = true; return; }
      g.insertAdjacentHTML('beforeend', vals.map(function (v) {
        return '<button type="button" class="ig-chip" aria-pressed="false" data-f="' + group + '" data-v="' + esc(skinVals[v].join(',')) + '">' + esc(v) + '</button>';
      }).join(''));
    }
    chips('skin', skins); // sin grupo «Evidencia» (Glosario §3.2, d7)

    function matches(li) {
      var ing = M[li.getAttribute('data-slug')];
      if (state.onlyRel && !relevant(ing)) return false;
      if (state.ev && na(li.getAttribute('data-ev')).indexOf(state.ev) < 0) return false;
      if (state.skin) { var ps = (li.getAttribute('data-skin') || '').split('|').map(function (x) { return na(x.trim()); }); if (!state.skin.split(',').some(function (k) { return ps.indexOf(k) >= 0; }) && ps.indexOf('todas') < 0) return false; }
      var v = na(state.q.trim());
      return !v || na(li.getAttribute('data-q')).indexOf(v) >= 0;
    }
    function render() {
      var shown = items.filter(matches);
      if (count) count.textContent = shown.length + ' ' + count.getAttribute('data-of') + ' ' + items.length + ' ' + count.getAttribute('data-label');
      items.forEach(function (li) { pool.appendChild(li); });
      list.innerHTML = '';
      if (empty) empty.hidden = shown.length > 0;
      var byG = {};
      shown.forEach(function (li) { (byG[li._g] = byG[li._g] || []).push(li); });
      var order = G.groups.map(function (g, i) { return i; }).sort(function (a, b) { return (G.groups[a].pos || 99) - (G.groups[b].pos || 99) || a - b; }).concat([-1]);
      order.forEach(function (gi) {
        var arr = byG[gi]; if (!arr || !arr.length) return;
        arr.sort(function (a, b) { return (+b.getAttribute('data-dots') - +a.getAttribute('data-dots')) || a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'), 'es'); });
        var name = gi >= 0 ? G.groups[gi].name : G.fallback;
        var wrap = document.createElement('div'); wrap.className = 'iggroup';
        wrap.innerHTML = '<div class="iggroup-h"><h3>' + esc(name) + '</h3><span class="n">' + arr.length + '</span></div><div class="ig-grid"></div>';
        var grid = wrap.querySelector('.ig-grid'); arr.forEach(function (li) { grid.appendChild(li); });
        list.appendChild(wrap);
      });
    }
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-f]');
      if (c) {
        var f = c.getAttribute('data-f'), val = c.getAttribute('data-v');
        state[f] = state[f] === val ? '' : val; // regla 4: exclusiva y un segundo clic la quita
        root.querySelectorAll('[data-f="' + f + '"]').forEach(function (b) { var on = state[f] === b.getAttribute('data-v'); b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        render(); return;
      }
      var r = e.target.closest('[data-ingx-onlyrel]');
      if (r) { state.onlyRel = !state.onlyRel; r.classList.toggle('on', state.onlyRel); r.setAttribute('aria-pressed', state.onlyRel ? 'true' : 'false'); render(); return; }
      var sb = e.target.closest('[data-ingx-set]');
      if (sb && window.EcoIngPDF) EcoIngPDF.run(sb, function () { return EcoIngPDF.set(routineIngredients(), sb.getAttribute('data-title')); });
    });
    if (q) q.addEventListener('input', function () { state.q = q.value; render(); });

    function paintProfile() {
      var perso = personalized(), nRel = 0;
      items.forEach(function (li) { var on = perso && relevant(M[li.getAttribute('data-slug')]); if (on) nRel++; var t = li.querySelector('[data-ingx-reltag]'); if (t) t.hidden = !on; });
      var diag = root.querySelector('[data-ingx-diag]'), badge = root.querySelector('[data-ingx-relcount]'), rel = root.querySelector('[data-ingx-onlyrel]');
      if (diag) diag.hidden = perso;
      if (badge) { badge.textContent = nRel + ' ' + badge.getAttribute('data-label'); badge.hidden = !(perso && nRel); }
      if (rel) { rel.hidden = !perso; if (!perso) { state.onlyRel = false; rel.classList.remove('on'); rel.setAttribute('aria-pressed', 'false'); } }
      render();
    }
    paintProfile();
    if (window.Eco) Eco.Profile.on(paintProfile);

    if (window.EcoCatalog) {
      EcoCatalog.load('all').then(function () {
        items.forEach(function (li) {
          var el = li.querySelector('[data-ingx-nprod]'); if (!el) return;
          var n = productsWith(li.getAttribute('data-slug')).length;
          el.textContent = n + ' ' + (n === 1 ? el.getAttribute('data-one') : el.getAttribute('data-many'));
        });
        var sb = root.querySelector('[data-ingx-set]'), ri = routineIngredients();
        if (sb && ri.length && window.EcoIngPDF) { sb.textContent = sb.getAttribute('data-label').replace('[n]', ri.length); sb.hidden = false; }
      }, function () {});
    }
  }

  /* Activos de la rutina guardada (regla 16): los que llevan los productos de eco_routine */
  function routineIngredients() {
    var r = null; try { r = JSON.parse(Eco.LS.get('eco_routine') || 'null'); } catch (e) {}
    if (!r || !r.steps) return [];
    var seen = {}, out = [], ING = ING_();
    r.steps.forEach(function (s) {
      var h = s.handle || (s.product && s.product.h); var p = h && window.EcoCatalog && EcoCatalog.byHandle(h); if (!p) return;
      (p.tags || []).forEach(function (t) { var n = na(t).replace(/\s+/g, ''); if (n.indexOf('activo:') === 0) { var slug = n.slice(7); if (!seen[slug] && ING[slug]) { seen[slug] = 1; out.push(slug); } } });
    });
    return out;
  }
  function ING_() { return bySlug(); }

  /* ---------- ficha ---------- */
  function card(p, L) {
    var tag = ''; try { var ex = (window.PRODUCTS_EXTRA || {})[p.h] || {}; tag = Eco.fitTag(Eco.data.toP({ handle: p.h, title: p.t, description: p.desc, product_type: p.product_type, tags: p.tags, custom: { inci: p.inci, activos_clave: ex.activos || [], tipos_piel: ex.piel || [] } }), true) || ''; } catch (e) {}
    var price = eur(p.price);
    return '<a class="ec-card" href="' + esc(p.u || (ROOT + 'products/' + p.h)) + '"><span class="ec-img">' + (tag ? '<span class="ec-tag">' + tag + '</span>' : '') +
      (p.img ? '<img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.t) + '">' : '') + '</span>' +
      '<span class="ec-body"><span class="ec-brand">' + esc(p.brand || L.brand) + '</span><span class="ec-name">' + esc(p.t) + '</span>' +
      '<span class="ec-foot"><span class="ec-price' + (price ? '' : ' ec-muted') + '">' + esc(price || L.ask) + '</span>' + (p.ok === true && L.seal ? '<span class="ec-seal">' + esc(L.seal) + '</span>' : '') + '</span></span></a>';
  }

  function initFicha(root) {
    var slug = root.getAttribute('data-ing-slug'), ing = bySlug()[slug];
    function paintRel() { var on = personalized() && relevant(ing); root.querySelectorAll('[data-ing-rel]').forEach(function (b) { b.hidden = !on; }); }
    paintRel(); if (window.Eco) Eco.Profile.on(paintRel);
    // Regla 14: registro de lectura para el reto del Club (sin duplicados, máx. 200)
    try {
      var club = JSON.parse(Eco.LS.get('eco_club') || 'null') || {}; club.reads = club.reads || [];
      if (club.reads.indexOf(slug) < 0) { club.reads.push(slug); club.reads = club.reads.slice(-200); Eco.LS.set('eco_club', JSON.stringify(club)); }
    } catch (e) {}
    var pdf = root.querySelector('[data-ing-pdf]'), setb = root.querySelector('[data-ing-set]');
    root.addEventListener('click', function (e) {
      if (!window.EcoIngPDF) return;
      if (e.target.closest('[data-ing-pdf]')) EcoIngPDF.run(pdf, function () { return EcoIngPDF.ficha(slug); });
      if (e.target.closest('[data-ing-set]')) EcoIngPDF.run(setb, function () { return EcoIngPDF.set(routineIngredients(), setb.getAttribute('data-title')); });
    });
    if (window.EcoCatalog) {
      EcoCatalog.load('all').then(function () {
        var n = productsWith(slug).length;
        root.querySelectorAll('[data-ing-nprod]').forEach(function (c) { c.textContent = n + ' ' + (n === 1 ? c.getAttribute('data-one') : c.getAttribute('data-many')); c.hidden = false; });
        var ri = routineIngredients();
        if (setb && ri.length > 1) { setb.textContent = setb.getAttribute('data-label').replace('[n]', ri.length); setb.hidden = false; } // regla 16: en la ficha, con más de 1
      }, function () {});
    }
  }
  /* «Productos que lo contienen (N)» (pantalla 10), sección aparte a ancho completo */
  function initProducts(box) {
    var slug = box.getAttribute('data-ing-products');
    if (!window.EcoCatalog) return;
    EcoCatalog.load('all').then(function () {
      var ps = productsWith(slug);
      var lim = parseInt(box.getAttribute('data-limit'), 10) || 12;
      var head = box.querySelector('[data-ing-products-title]');
      if (head) head.textContent = head.getAttribute('data-title').replace('[n]', ps.length);
      var grid = box.querySelector('[data-ing-products-grid]'), emptyEl = box.querySelector('[data-ing-products-empty]');
      var L = { seal: box.getAttribute('data-seal') || '', ask: box.getAttribute('data-ask') || '', brand: box.getAttribute('data-brand') || '' };
      grid.innerHTML = ps.slice(0, lim).map(function (p) { return card(p, L); }).join('');
      grid.hidden = !ps.length;
      if (emptyEl) emptyEl.hidden = ps.length > 0;
      // el título dice N: si la rejilla se corta en el máximo, «Ver todos» lleva al catálogo filtrado
      var all = box.querySelector('[data-ing-products-all]');
      if (all) { var a = all.querySelector('a'); if (a) a.textContent = a.getAttribute('data-label').replace('[n]', ps.length); all.hidden = ps.length <= lim; }
    }, function () {});
  }

  function init() {
    document.querySelectorAll('[data-jm-ingx]').forEach(initIndex);
    document.querySelectorAll('[data-ing-slug]').forEach(initFicha);
    document.querySelectorAll('[data-ing-products]').forEach(initProducts);
  }
  // arranque robusto: espera a eco-core.js (se carga al final del body) sin depender del orden de DOMContentLoaded
  (function boot(n) { if (window.Eco || n > 200) init(); else setTimeout(function () { boot(n + 1); }, 30); })(0);
})();
